export function usePushNotificationApi() {
  const { request } = useRequest();

  async function getNotificationsByUser(requestBody: GetUserNotificationsDTO) {
    const url = 'V4/PushNotification/GetNotificationsByUser';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: false
    };

    return await request<NotificationPageResponseDTO>(url, requestOptions);
  }

  async function markNotificationAsRead(requestBody: MarkNotificationAsReadDTO) {
    const url = 'V4/PushNotification/MarkNotificationAsRead';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: false
    };

    return await request<boolean>(url, requestOptions);
  }

  async function markAllNotificationsAsRead(requestBody: MarkAllNotificationsAsReadDTO) {
    const url = 'V4/PushNotification/MarkAllNotificationsAsRead';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: false
    };

    return await request<boolean>(url, requestOptions);
  }

  async function markNotificationAsAcknowledged(requestBody: MarkNotificationAsAcknowledgedDTO) {
    const url = 'V4/PushNotification/MarkNotificationAsAcknowledged';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody,
      isAnonymous: false
    };

    return await request<boolean>(url, requestOptions);
  }

  return {
    getNotificationsByUser,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    markNotificationAsAcknowledged
  };
}